export const LOCALE_FLAGS = {
  'en': '🇺🇸',    // or 🇬🇧 for UK
  'es': '🇪🇸',
  'de_DE': '🇩🇪',
  'pt_BR': '🇧🇷'
}

export type LocaleKey = keyof typeof LOCALE_FLAGS 